"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { shopifyTrustedLogos } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyDeveloperMarqueeProps {
  title?: string;
  className?: string;
  speed?: number;
}
export default function ShopifyDeveloperMarquee(t0) {
  const $ = _c(20);
  const {
    title: t1,
    className: t2,
    speed: t3
  } = t0;
  const title = t1 === undefined ? "Trusted by Startups and Big Brands" : t1;
  const className = t2 === undefined ? "" : t2;
  const speed = t3 === undefined ? 45 : t3;
  const desktopAnimations = useDesktopAnimations();
  let t4;
  if ($[0] !== desktopAnimations) {
    t4 = desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false;
    $[0] = desktopAnimations;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== desktopAnimations) {
    t5 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== desktopAnimations) {
    t6 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      once: true
    };
    t8 = {
      duration: 0.7,
      delay: 0.25,
      ease
    };
    $[6] = t7;
    $[7] = t8;
  } else {
    t7 = $[6];
    t8 = $[7];
  }
  const t9 = `w-full max-w-322.5 mx-auto px-3.75 pb-10 md:pb-14 text-center ${className}`;
  let t10;
  if ($[8] !== title) {
    t10 = title && <h2 className="font-poppins mt-6 mb-8 text-site-18px font-bold text-site-0b1354 sm:mt-8 md:text-site-20px dark:text-white">{title}</h2>;
    $[8] = title;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = shopifyTrustedLogos.map(_temp);
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== speed) {
    t12 = <Marquee gradient={false} speed={speed} pauseOnHover={true} autoFill={true} className="overflow-hidden">{t11}</Marquee>;
    $[11] = speed;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t10 || $[14] !== t12 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t9) {
    t13 = <motion.div initial={t4} whileInView={t5} animate={t6} viewport={t7} transition={t8} className={t9}>{t10}{t12}</motion.div>;
    $[13] = t10;
    $[14] = t12;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t9;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
}
function _temp(logo, index) {
  return <div key={`${logo.alt}-${index}`} className="mx-6 flex shrink-0 items-center justify-center sm:mx-8 md:mx-12 dark:rounded-md dark:bg-white dark:px-5 dark:py-3 dark:shadow-sm"><Image src={logo.src} alt={logo.alt} width={240} height={100} loading="lazy" className="h-13 w-auto max-w-40 object-contain opacity-80 transition-all duration-300 hover:scale-105 hover:opacity-100 md:h-18 md:max-w-50 dark:opacity-100" /></div>;
}